export default {
    events: {},
    effects: {},
}